import React from 'react';
import { v4 as uuid } from 'uuid';
import { Link } from 'react-router-dom';
import { getLocalizedDateTime } from '../../localization/LocalizedString';
import ExportInstallationDocumentPdf from './ExportInstallationDocumentPdf';
import PreviewPDFButton from './PreviewPDFButton';
import './ServiceTable.css';

class InstallationDocumentListItem extends React.Component {
  previewHandlerWithShipmentID = (pdfName) => {
    const { previewButtonHandler } = this.props;
    if (pdfName !== undefined) {
      previewButtonHandler(pdfName);
    }
  }

  render() {
    const {
      item, currentLanguage, modalButton, reasonModalHandler,
    } = this.props;
    const {
      user, employeeId, businessCustomer, endCustomer, device, task, companyName, date, orderData,
    } = item;
    const {
      name, address, place, pdfName,
    } = endCustomer;
    const { deviceNamesFi, deviceNamesEn } = device;
    const { duration } = task;
    const deviceNamesFiString = deviceNamesFi.map((deviceData) => (
      <div>
        {deviceData.name}
        {' '}
        {deviceData.device.status !== undefined && deviceData.device.status.value === 'NOT_INSTALLED'
          ? (
            <Link className="link"
                  to={{ key: uuid() }}
                  onClick={() => {
                    reasonModalHandler({ msg: deviceData.device.status.reason, showReasonModal: true, deviceName: deviceData.name });
                  }}>
              <span>
                {' '}
                (
                {deviceData.device.status.value === 'NOT_INSTALLED' ? 'Ei asennettu' : ''}
              </span>
              )
              {' '}
            </Link>
          ) : '' }
      </div>
    ));

    const deviceNamesEnString = deviceNamesEn.map((deviceData) => (
      <div>
        {deviceData.name}
        {' '}
        {deviceData.device.status !== undefined && deviceData.device.status.value === 'NOT_INSTALLED'
          ? (
            <Link className="link" to={{ key: uuid() }} onClick={() => { reasonModalHandler({ msg: deviceData.device.status.reason, showReasonModal: true, deviceName: deviceData.name }); }}>
              <span>
                {' '}
                (
                {deviceData.device.status.value === 'NOT_INSTALLED' ? 'Not Installed' : ''}
              </span>
              )
              {' '}
            </Link>
          )
          : ''}
      </div>
    ));

    return (
      <tr className="report-table-row_service">
        <td className="report-table-cell_service">{user}</td>
        <td className="report-table-cell_service">{employeeId}</td>
        <td className="report-table-cell_service">{getLocalizedDateTime(new Date(date), currentLanguage)}</td>
        <td className="report-table-cell_service">{businessCustomer}</td>
        <td className="report-table-cell_service">{orderData.consignorName}</td>
        <td className="report-table-cell_service">{companyName}</td>
        <td className="report-table-cell_service">{name}</td>
        <td className="report-table-cell_service">{address}</td>
        <td className="report-table-cell_service">{place}</td>
        <td className="report-table-cell_service">
          {(currentLanguage === 'fi')
            ? deviceNamesFiString
            : deviceNamesEnString}
        </td>
        <td className="report-table-cell_service">{modalButton}</td>
        <td className="report-table-cell_service">{duration}</td>
        <td className="report-table-cell_service pdf-export-cell">
          <span style={{ cursor: 'pointer' }}>
            <ExportInstallationDocumentPdf installationDocumentId={pdfName}
                                           handlePreviewButton={this.previewHandlerWithShipmentID} />
          </span>
          <span style={{ position: 'relative', left: '10px', cursor: 'pointer' }}>
            <PreviewPDFButton installationDocumentId={pdfName}
                              handlePreviewButton={this.previewHandlerWithShipmentID} />
          </span>
        </td>
      </tr>
    );
  }
}

export default InstallationDocumentListItem;
